import React from 'react';
import type { MenuCategory, MenuItem } from '../../types/workspace';
import MenuItemRow from './MenuItemRow';

interface MenuSectionPanelProps {
  category: MenuCategory;
  items: MenuItem[];
  itemHrefBuilder?: (item: MenuItem) => string;
}

const MenuSectionPanel: React.FC<MenuSectionPanelProps> = ({ category, items, itemHrefBuilder }) => {
  return (
    <section className="arab-panel overflow-hidden">
      <div className="grid gap-0 lg:grid-cols-[320px_1fr]">
        <div className="relative min-h-[220px] overflow-hidden border-b border-white/8 lg:border-b-0 lg:border-r">
          <img src={category.coverImage} alt={category.title} className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#110706] via-transparent to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-5">
            <div className="arab-gold-text text-3xl font-semibold">{category.title}</div>
            <div className="mt-2 max-w-xs text-sm text-white/65">{category.shortDescription}</div>
          </div>
        </div>

        <div className="p-4 sm:p-6">
          <div className="space-y-3">
            {items.map((item) => (
              <MenuItemRow
                key={item.id}
                item={item}
                href={itemHrefBuilder ? itemHrefBuilder(item) : undefined}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MenuSectionPanel;
